// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8729) return "static/chunks/ui-components-26aa2bf5c57636dc.js";
	if (chunkId === 8592) return "static/chunks/common-b670e4d805179216.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3756":"1567618a75bcc0b3","9570":"cdba720c557cef99"}[chunkId] + ".js";
};